export type SciMailKind = 'rent' | 'transaction';

export type SciMailWindowChoice = {
  kind: SciMailKind;
  templateKey: string;
};

export type SciMailWindow = {
  year: number;
  sciIndex: 1 | 2 | 3;
  plannedLabel: string;
  plannedDate: string; // YYYY-MM-DD
  kind: SciMailKind | null;
  templateKey: string | null;
};

export type SciMailWindowsMap = Record<string, SciMailWindowChoice>;

export const buildSciMailWindowKey = (year: number, sciIndex: 1 | 2 | 3): string => `${year}:${sciIndex}`;
